/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useState} from 'react'
import {Column} from 'react-table'
import {KTCard} from '../../../../../../../../_metronic/helpers'
import {KTable, KTableHeader, KTableLoading} from '../../../../../../components/UI'
import {KTableProvider} from '../../../../../../contexts/KTableProvider'
import {RatioCheckinOutCompanyColumn} from '../../../../models/reports.model'
import {getSnackBar, getSnackBarToast} from '../../../../../../util/snackBar'
import moment from 'moment'
import {
  getRatioCheckInOutCampCSVService,
  getRatioCheckInOutCampExcelService,
  getRatioCheckInOutCampPDFService,
} from '../../../../services/ratio.service'
import {SnackbarProvider} from 'notistack'

interface Props {
  datos: RatioCheckinOutCompanyColumn[]
  loading: boolean
  formValue: any
}

const TableReportRatioCheckinoutCompany: FC<Props> = ({datos, loading, formValue}) => {
  //   useEffect(() => {
  //     setLoading(loading)
  //     // eslint-disable-next-line react-hooks/exhaustive-deps
  //   }, [loading])

  const [isDownloadXLS, setIsDownloadXLS] = useState<boolean>(false)
  const [isDownloadCSV, setIsDownloadCSV] = useState<boolean>(false)
  const [isDownloadPDF, setIsDownloadPDF] = useState<boolean>(false)

  const columns: Column<RatioCheckinOutCompanyColumn>[] = [
    {
      Header: (props) => <KTableHeader tableProps={props} title='Campamento' />,
      accessor: 'Descripcion',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Total CheckIn Programados' />,
      accessor: 'TotalCheckInProgramados',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Total CheckIn Realizados' />,
      accessor: 'TotalCheckInRealizados',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Total CheckOut Programados' />,
      accessor: 'TotalCheckOutProgramados',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Total CheckOut Realizados' />,
      accessor: 'TotalCheckOutRealizados',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Ratio CheckIn' />,
      accessor: 'RatioCheckInPorc',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Ratio CheckOut' />,
      accessor: 'RatioCheckOutPorc',
    },
  ]

  const handleExportXLS = async () => {
    try {
      setIsDownloadXLS(true)
      const response = await getRatioCheckInOutCampExcelService(formValue)
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      // Crea un enlace temporal y simula un clic para descargar el archivo
      moment().format('DD/MM/YY HH:mm').toString()
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `Ratios CheckInOut Campamento-${moment()
        .format('DD/MM/YY HH:mm')
        .toString()}.xlsx` // Ajusta el nombre del archivo según tus necesidades
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      getSnackBarToast('Se descargó el documento con éxito', 'success')
      setIsDownloadXLS(false)
    } catch (error) {
      getSnackBarToast('Hubo un error al descargar', 'error')
      setIsDownloadXLS(false)
    }
  }
  const handleExportCSV = async () => {
    try {
      setIsDownloadCSV(true)
      const response = await getRatioCheckInOutCampCSVService(formValue)
      const blob = new Blob([response.data], {
        type: 'application/pdf',
      })
      // Crea un enlace temporal y simula un clic para descargar el archivo
      moment().format('DD/MM/YY HH:mm').toString()
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `Ratios CheckInOut Campamento-${moment()
        .format('DD/MM/YY HH:mm')
        .toString()}.csv` // Ajusta el nombre del archivo según tus necesidades
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      getSnackBarToast('Se descargó el documento con éxito', 'success')
      setIsDownloadCSV(false)
    } catch (error) {
      getSnackBarToast('Hubo un error al descargar', 'error')
      setIsDownloadCSV(false)
      //
    }
  }
  const handleExportPDF = async () => {
    try {
      setIsDownloadPDF(true)
      const response = await getRatioCheckInOutCampPDFService(formValue)
      const blob = new Blob([response.data], {
        type: 'text/csv',
      })
      // Crea un enlace temporal y simula un clic para descargar el archivo
      moment().format('DD/MM/YY HH:mm').toString()
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `Ratios CheckInOut Campamento-${moment()
        .format('DD/MM/YY HH:mm')
        .toString()}.pdf` // Ajusta el nombre del archivo según tus necesidades
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      getSnackBarToast('Se descargó el documento con éxito', 'success')
      setIsDownloadPDF(false)
    } catch (error) {
      getSnackBarToast('Hubo un error al descargar', 'error')
      setIsDownloadPDF(false)
    }
  }

  return (
    <>
      <KTCard shadow className='m-5'>
        <div className='d-flex justify-content-end p-2 me-5'>
          <button
            type='button'
            className='btn btn-success me-3'
            disabled={datos.length < 1 || isDownloadXLS}
            onClick={handleExportXLS}
          >
            {isDownloadXLS && (
              <div className='icon-container'>
                <i className='loader'></i>
              </div>
            )}
            Descargar Excel
          </button>
          <button
            type='button'
            className='btn btn-success me-3'
            disabled={datos.length < 1 || isDownloadCSV}
            onClick={handleExportCSV}
          >
            {isDownloadCSV && (
              <div className='icon-container'>
                <i className='loader'></i>
              </div>
            )}
            Descargar CSV
          </button>
          <button
            type='button'
            className='btn btn-success me-3'
            disabled={datos.length < 1 || isDownloadPDF}
            onClick={handleExportPDF}
          >
            {isDownloadPDF && (
              <div className='icon-container'>
                <i className='loader'></i>
              </div>
            )}
            Descargar PDF
          </button>
        </div>
        {loading ? <KTableLoading title='Cargando...' /> : null}
        <KTable data={datos} columns={columns} showPagination={false} />
      </KTCard>
    </>
  )
}

const TableReportRatioCheckinoutCompanyWrapper: FC<Props> = ({datos, loading, formValue}) => {
  return (
    <KTableProvider>
      <TableReportRatioCheckinoutCompany datos={datos} loading={loading} formValue={formValue} />
      <SnackbarProvider />
    </KTableProvider>
  )
}

export {TableReportRatioCheckinoutCompanyWrapper}
